import { TYPE_STRING } from './input-types';

export const id = 'paymentMethod';
export const apiKey = 'PaymentMethod';
export const type = TYPE_STRING;

export const paymentMethod = {
  id,
  apiKey,
  type,
};
